export const proxyPolyfillCompat = {
  settings: null,
  defaultConfig: null,
  fetchTimeMillis: null,
  lastFetchStatus: null,
  activate: null,
  ensureInitialized: null,
  fetch: null,
  fetchAndActivate: null,
  getAll: null,
  getBoolean: null,
  getNumber: null,
  getString: null,
  getValue: null,
  setLogLevel: null,
};
